export const filterByTeam = (matches, teams) =>
    matches.filter(
        (item) =>
            teams.includes(item.home?.team?.id) ||
            teams.includes(item.away?.team?.id)
    );
